import type { TransicaoDisponivel } from '../../api/tipos.js';

export interface EstadoTrilho {
  nome: string;
  percorrido: boolean;
  atual: boolean;
}

interface TrilhoEstadoProps {
  estados: EstadoTrilho[];
  transicoesDisponiveis: TransicaoDisponivel[];
  onSelecionarTransicao: (transicao: TransicaoDisponivel) => void;
}

// SPEC-UX §3.1 — componente assinatura: estados percorridos (preenchidos),
// estado atual (destacado), próximos possíveis (contorno). Clique em
// próximo estado mostra a guarda (o que falta), via onSelecionarTransicao
// que abre o Modal de Transição (§3.2). Fonte única: tabela de transições
// do core — nunca hard-coded aqui, sempre vem de GET /:recurso/:id/transicoes.
export function TrilhoEstado({ estados, transicoesDisponiveis, onSelecionarTransicao }: TrilhoEstadoProps) {
  return (
    <div className="flex items-center gap-1" role="list" aria-label="Trilho de estado">
      {estados.map((estado, i) => {
        const transicaoParaEsteEstado = transicoesDisponiveis.find((t) => t.para === estado.nome);

        return (
          <div key={estado.nome} className="flex items-center gap-1" role="listitem">
            {i > 0 && <div className={`h-px w-4 ${estado.percorrido || estado.atual ? 'bg-aco' : 'bg-borda'}`} aria-hidden="true" />}
            <button
              type="button"
              disabled={!transicaoParaEsteEstado}
              onClick={() => transicaoParaEsteEstado && onSelecionarTransicao(transicaoParaEsteEstado)}
              className={[
                'rounded-full border px-3 py-1 text-xs font-medium transition-colors',
                estado.atual
                  ? 'border-aco bg-aco text-white'
                  : estado.percorrido
                    ? 'border-aco/40 bg-aco/10 text-aco-700'
                    : transicaoParaEsteEstado?.disponivel
                      ? 'cursor-pointer border-aco/50 text-aco hover:bg-aco/5'
                      : 'border-dashed border-borda text-grafite',
              ].join(' ')}
            >
              {estado.nome}
            </button>
          </div>
        );
      })}
    </div>
  );
}
